import { queryOptions } from "@tanstack/react-query";
import type { ApiClient } from "@/lib/api";
import { getEngineApi } from "@/lib/api";
import type { OrgProjectScope } from "@/lib/resource-context";
import { oauthProvidersKeys } from "./query-keys";

type MetadataPage = { total_count?: number };

const fetchOAuthProvidersCount = async ({
  client,
}: {
  client: ApiClient;
}): Promise<number> => {
  // total_count reflects the full set regardless of limit; fetch one row.
  const { data } = await client.get<MetadataPage>("/auth_providers/metadata", {
    params: { limit: 1, offset: 0 },
  });
  return data?.total_count ?? 0;
};

export const oauthProvidersCountQueryOptions = ({
  scope,
}: {
  scope: OrgProjectScope;
}) => {
  const client = getEngineApi(scope, "project");

  return queryOptions({
    queryKey: [...oauthProvidersKeys.lists({ scope }), "metadata-count"],
    queryFn: () => fetchOAuthProvidersCount({ client }),
  });
};
